import { RadioInput, RadioLabel, RadioWrapper } from "./radio.styles";
import { RadioProps } from "./radio.types";

const RadioButton = ({
  id,
  label = "",
  checked,
  onChange
}: RadioProps): JSX.Element => {
  return (
    <RadioWrapper>
      <RadioInput type="radio" checked={checked} onChange={onChange} id={id} />
      {label && <RadioLabel htmlFor={id}>{label}</RadioLabel>}
    </RadioWrapper>
  );
};

export { RadioButton };
